import { KnownOrderStatus } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { Paths, ProjectPathParams } from '../../../../../app/router/app.router';
import { RetailStatusCountCard } from './retail-status-count-card.component';
import { useStatusCountGridStyles } from './retail-status-count-grid.styles';

export const RetailStatusCountGrid = React.memo(function StatusCountGrid({
  params
}: {
  params: ProjectPathParams<Paths.dashboard>;
}) {
  const classes = useStatusCountGridStyles();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isLg = useMediaQuery(theme.breakpoints.up(1135));

  const spacing = isXs ? 2 : 3;

  return (
    /* Main grid */
    <Grid
      container
      spacing={spacing}
      direction="row"
      wrap={isSm || isXs ? 'wrap' : 'nowrap'}
      style={isXs ? { overflow: 'hidden' } : undefined}
    >
      {/* Small Cards */}
      <Grid
        container
        wrap="nowrap"
        spacing={spacing}
        sx={{
          justifyContent: 'space-between',
          flexDirection: isLg || isSm ? 'row' : 'column'
        }}
      >
        {/* Col 1 of 3 */}
        <Grid
          container
          spacing={spacing}
          wrap="nowrap"
          sx={{
            justifyContent: 'space-between',
            flexDirection: isLg || isSm ? 'column' : 'row'
          }}
        >
          <Grid container>
            <RetailStatusCountCard size="small" status={KnownOrderStatus.Booked} params={params} />
          </Grid>
          <Grid container>
            <RetailStatusCountCard size="small" status={KnownOrderStatus.RetrievalRequired} params={params} />
          </Grid>
        </Grid>
        {/* Col 2 of 3 */}
        <Grid
          container
          spacing={spacing}
          wrap="nowrap"
          sx={{
            justifyContent: 'space-between',
            flexDirection: isLg || isSm ? 'column' : 'row'
          }}
        >
          <Grid container>
            <RetailStatusCountCard size="small" status={KnownOrderStatus.Delivered} params={params} />
          </Grid>
          <Grid container>
            <RetailStatusCountCard size="small" status={KnownOrderStatus.Retrieved} params={params} />
          </Grid>
        </Grid>
        {/* Col 3 of 3 */}
        <Grid
          container
          spacing={spacing}
          wrap="nowrap"
          sx={{
            justifyContent: 'space-between',
            flexDirection: isLg || isSm ? 'column' : 'row'
          }}
        >
          <Grid container>
            <RetailStatusCountCard size="small" status={KnownOrderStatus.Overdue} params={params} />
          </Grid>

          <Grid container>
            <RetailStatusCountCard size="small" status={KnownOrderStatus.Cancelled} params={params} />
          </Grid>
        </Grid>
      </Grid>
      {/* Large card */}
      <Grid
        className={classes.largeCard}
        container
        size={{
          lg: 4,
          md: 5,
          sm: 12,
          xs: 12
        }}
      >
        <RetailStatusCountCard size="large" status={KnownOrderStatus.Collected} params={params} />
      </Grid>
    </Grid>
  );
});
